import { City, Page } from '@flyblack/common/domains';

import { api } from '@/services/network/api';

export const getCities: (page, size) => Promise<Page<City>> = (pageNumber, pageSize) =>
  api.get(`/v1/cities`, { pageNumber, pageSize });
